import baseTheme from '../baseTheme';
import colors from '../colors';
export var MuiOutlinedInput = {
    input: {
        padding: '14px 18px 13px',
        '&::placeholder': {
            color: baseTheme.palette.text.disabled,
        },
    },
    notchedOutline: {
        borderWidth: '2px',
        borderColor: baseTheme.palette.grey[300],
        transition: 'none',
        // Handles the notched inset
        fontSize: '1.35em',
        '& legend': {
            transition: 'none',
        },
    },
    root: {
        // this disables MUI's default border color on focused inputs
        '&$focused $notchedOutline': {
            borderColor: baseTheme.palette.grey[300],
        },
        // we increase specificity here to direct children because in very
        // particular corner cases (like FileInput) the root element of
        // an "OutlinedInput" may nest other OutlinedInput-based components
        '&$focused > $notchedOutline': {
            borderColor: baseTheme.palette.grey[500],
            boxShadow: "inset 8px 0 0 " + baseTheme.palette.primary.light,
        },
        '&$error $notchedOutline': {
            borderColor: colors.orange[200],
        },
        '&$focused$error $notchedOutline': {
            boxShadow: "inset 8px 0 0 " + baseTheme.palette.error.light,
            borderColor: baseTheme.palette.error.main,
        },
        '&:hover $notchedOutline': {
            borderColor: baseTheme.palette.grey[300],
        },
        '&$disabled': {},
    },
    inputMarginDense: {
        paddingLeft: '12px',
        paddingRight: '12px',
        paddingBottom: '4px',
        paddingTop: '4px',
    },
};
//# sourceMappingURL=MuiOutlinedInput.js.map